import query from './APIServices'

export interface VehicleParams {
  id?: number
  name: string
  identification?: string
  oficialNumber?: string
  type: 'TRUCK' | 'CAR' | 'VAN' | 'MOTORCYCLE' | 'BIKE' | 'OTHER'
  maxWeight?: number
  maxHeight?: number
  operatedById?: number
  commission: {
    amount: number
    mode: string
    codeCurrency: string
  }
}

export const createNewVehicle = async (params: VehicleParams) =>
  await query.post('/cargo/vehicle', params)

export const editNewVehicle = async (params: VehicleParams) =>
  await query.patch(`/cargo/vehicle/${params.id}`, {
    name: params.name,
    identification: params.identification,
    oficialNumber: params.oficialNumber,
    type: params.type,
    maxWeight: params.maxWeight,
    maxHeight: params.maxHeight,
    operatedById: params.operatedById,
    commission: params.commission,
  })

export const deleteVehicle = async (idVehicle: number) =>
  await query.deleteAPI(`/cargo/vehicle/${idVehicle}`)

export const getVehiclesByCompany = async (companyId: number) => {
  const response = await query.get('/cargo/vehicle', {
    params: { operatedById: companyId },
  })
  return response.data.items
}
